export default __webpack_public_path__ + "scripts/jsstore.worker.min.5c2b74f8f6851c8a58375cff47b407e9.js";